var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-wh"},[(!_vm.$route.params.communityId)?_c('layout-main',{scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('layout-tool-bar')]},proxy:true}],null,false,2156595538)},[_c('v-container',{staticClass:"fill-wh"},[_c('router-view')],1)],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }